module.exports = __webpack_public_path__ + "static/404-fff5c494446ad20151eee73fce7f2ee8.png";